module.exports = __webpack_public_path__ + "media/images/career_camp/2023/stats_illustration_1-1426d373ed3a73fb3a8691f0e2bc2765.svg";